(() => {
  const init = (root) => {
    if (!root || root.dataset.delaCampaignReady === 'true') return;
    root.dataset.delaCampaignReady = 'true';
    const track = root.querySelector('[data-dela-campaign-track]');
    const slides = [...root.querySelectorAll('[data-dela-campaign-slide]')];
    const dots = [...root.querySelectorAll('[data-dela-campaign-dot]')];
    const prev = root.querySelector('[data-dela-campaign-prev]');
    const next = root.querySelector('[data-dela-campaign-next]');
    if (!track || slides.length < 2) return;

    let current = 0;
    let raf = null;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollToIndex = (index) => {
      current = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      update();
    };
    const update = () => {
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    };
    const syncFromScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const left = track.getBoundingClientRect().left;
        let best = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const d = Math.abs(slide.getBoundingClientRect().left - left);
          if (d < distance) { distance = d; best = i; }
        });
        current = best;
        update();
      });
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => scrollToIndex(i)));
    prev?.addEventListener('click', () => scrollToIndex(current - 1));
    next?.addEventListener('click', () => scrollToIndex(current + 1));
    track.addEventListener('scroll', syncFromScroll, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); scrollToIndex(current + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); scrollToIndex(current - 1); }
    });
    update();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-dela-campaign-deck]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
